export default "/_next/static/chunks/fonts/Karla-Regular-latin-5a902e16f4703a1c65104f9a189b0969.woff2";